export const storeProducts = [
  {
    id: 1,
    title: "Google Pixel 4",
    img: "img/product-1.png",
    price: 10,
    info:
        `Google Pixel 4 is the company's new flagship device, designed to adapt to users. The model received a completely redesigned design, complemented by new non-standard design schemes. The 5.7-inch screen of Google Pixel 4 is made according to OLED technologies in compliance with the parties 19: 9. It supports HDR, and its refresh rate reaches 90 Hz.
        The changes affected the multitasking mode, the smartphone additionally got the ability to control gestures without touching, as well as an improved voice assistant. All this makes Google Pixel 4 the most interesting device for those who want to be on the cutting edge of technology.`,    inCart: false,
    total: 0
  },
  {
    id: 2,
    title: "Samsung Galaxy S10",
    img: "img/product-2.png",
    price: 16,
    info:
      `Samsung Galaxy S10 SM-G9730 DS is the flagship smartphone in which the manufacturer showed that, in his opinion, it is worth making high-tech solutions. The casing is made of aluminum and protected against dust and moisture according to IP68. The AMOLED 6.1-inch dynamic screen covers almost the entire surface of the front panel. The main camera is triple, and consists of 2 modules at 12 MP and one 16 MP. Front 10 MP, with support for face recognition technology. One of the features of the Samsung Galaxy S10 SM-G9730 DS is the reverse wireless charging, with which you can charge other devices, such as watches or headphones.`,    inCart: false,
    total: 0
  },
  {
    id: 3,
    title: "HTC U12",
    img: "img/product-3.png",
    price: 8,
    info:
      "HTC U12 demonstrates a new approach: pressure-sensitive keys, smart interactive faces that make device management with one hand even more convenient, dual camera, unsurpassed sound quality and the most advanced mobile platform Snapdragon 845. Thanks to the new generation of Edge Sense technology, HTC U12 is able to recognize, in which hand you hold the device, and in addition to the ability to control compression, there are such new actions as double-touch and capture.",
    total: 0
  },
  {
    id: 4,
    title: "Samsung Galaxy Fold",
    img: "img/product-4.png",
    price: 18,
    info:
      `Samsung Galaxy Fold - a flexible smartphone, a new milestone in the creation of portable devices, as well as the opportunity for the company to demonstrate its entire technological arsenal. The case of the device is made of glass and aluminum, and most importantly, it has 2 screens, one of which is bent. In the folded position, a 4.6-inch Super AMOLED matrix with a 21: 9 aspect ratio is used. But it’s worth revealing the Samsung Galaxy Fold, as the user opens a 7.3-inch Dynamic AMOLED screen with an aspect ratio of 4.2: 3. In this case, the active application is immediately transferred to an additional display, which also supports multitasking.`,
    total: 0
  },
  {
    id: 5,
    title: "HUAWEI P40 Pro",
    img: "img/product-5.png",
    price: 24,
    info:
      "The HUAWEI P40 Pro is the flagship device in which the manufacturer tried to raise to the absolute not only excellent technical equipment, but also framelessness. The 6.58-inch display not only covers the entire front surface, but is also slightly bent to the side faces. This gives the impression that you are holding the image directly in the palm of your hand. The HUAWEI P40 Pro OLED matrix can surprise you with high image quality and color depth, as well as amazing smoothness thanks to a refresh rate of 90 Hz. It also has a built-in fingerprint scanner.",
    total: 0
  },
  {
    id: 6,
    title: "Apple iPhone 11 Pro Max",
    img: "img/product-6.png",
    price: 17,
    info:
      "The iPhone 11 Pro Max is the largest iPhone in 2019. Thanks to the diagonal of 6.5 inches, not only the usability and information content has grown, but also the battery capacity, which, combined with the energy-efficient and powerful Apple A13 Bionic processor, allows the smartphone to work 1.5-2 days or 1 day stably under high load. But the smartphone has become not only faster than the iPhone XS Max, but its photographic capabilities have reached a different level. Now the smartphone has 3 cameras that cover the main focal lengths. This will be useful for both photos and videos, since the iPhone 11 Pro Max has an optical stabilization function.",
    total: 0
  },
  {
    id: 7,
    title: "Motorola RAZR 2019",
    img: "img/product-7.png",
    price: 30,
    info:
      "Motorola RAZR XT200-1 is not like the others. It has an original design and combines broad functionality and innovative technologies in a small convenient housing. A special water-repellent nanocoating protects the device from drops and splashes inside and out. The advanced folding mechanism works with the highest precision and is designed for intensive use. One easy movement - and the compact device turns into a modern smartphone with a large bright screen. When unfolded, the Motorola RAZR XT200-1 screen looks like a single unit: without visible joints and seams. That is why the picture on the screen is reproduced in excellent quality, without the slightest distortion at the place of docking.",
    total: 0
  },
  {
    id: 8,
    title: "Xiaomi Mi 10 Pro",
    img: "img/product-8.png",
    price: 18,
    info:
      "Xiaomi Mi Note 10 Pro is a smartphone for those who are looking for a universal device capable of equally well performing any task. He received a modern frameless design in which a 6.47-inch display occupies almost the entire surface of the front panel. The 32 MP front camera is hidden in a small drop-shaped notch. Xiaomi Mi Note 10 Pro has an AMOLED matrix with a resolution of 2340 × 1080 pixels, which also has a built-in fingerprint scanner.",
    total: 0
  }
];
